export enum PRODUCT_STATE {
  NOT_READY_FOR_PROCESSING = 0,
  READY_FOR_PROCESSING = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  REJECTED = 4,
  CANCELED = 5,
}
